import React from "react";
import { WhatsApp, EmailOutlined } from "@material-ui/icons";
import { Container } from "./styles";

function chooseIcon(key) {
  if (key == "whatsapp")
    return <WhatsApp key={key} style={{ color: "#7AD06D" }} />;

  if (key == "email")
    return <EmailOutlined key={key} style={{ color: "#3D9BE9" }} />;
}

export default function ReplySourcesSended({ ack }) {
  return (
    <Container>{Object.keys(ack).map((key) => chooseIcon(key))}</Container>
  );
}
